import { Vue, Component } from 'vue-property-decorator';

@Component
export default class StatusMarkMixin extends Vue {
  public getStatusMarkStyle = (status: string, {
    width = '7px',
    height = '7px',
    borderRadius = '50%',
    flexShrink = '0',
  } = {}, isLighten = false): {
    [key: string]: string
  } | null => {
    if (!status) return null;

    const colorByStatus = {
      created: '#623ec7',
      intransit: '#ffa43c',
      exception: '#cb0f51',
      delivered: '#2bc5cb',
    };

    const lightenColorByStatus = {
      created: '#5697FF',
      intransit: '#FF9F3D',
      exception: '#B663C7',
      delivered: '#2CC6CC',
    };

    const backgroundColor = isLighten ? lightenColorByStatus[status.replaceAll(' ', '').toLowerCase()] : colorByStatus[status.replaceAll(' ', '').toLowerCase()];

    return {
      width,
      height,
      borderRadius,
      flexShrink,
      backgroundColor,
    };
  }
}
